import React, { useEffect, useState } from 'react';
import Search from "../search/search";
import { Close, DeleteIcon, EditIcon } from "../../icons/icons";
import Pagination from "../pagination/pagination";
import DropDown from "../../assets/dropDown/dropDown";
import Sort from "../sort/sort";
import { GetViewType } from "../../utils/view-type";
import Filter from "../filter/filter";
import useDirection from "../../hooks/useDirection";
import { useTranslation } from "react-i18next";
import { Delete, Get } from "../../apis/api";
import LoadingFix from "../loading-fix/loading-fix";
import DeleteModal from "../deleteModal/deleteModal";
import { setting } from "../../store/setting/setting.reducer";
import { toast } from "react-toastify";
import CustomCheckBox from "../UI/customCheckBox/customCheckBox";
import { useSelector } from 'react-redux';
;

const ShipTable = ({ defaultValue, defaultValueSelected, editItem, onClose, onClear, onChange, selectShip }) => {
  const viewType = GetViewType()
  const directionClass = useDirection();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [deleteItem, setDeleteItem] = useState(null)
  const [loadingDelete, setLoadingDelete] = useState(false)
  const [fileModal, setFileModal] = useState("")
  const [perPage, setPerPage] = useState(10)
  const [searchTime, setSearchTime] = useState("")
  const countryList = useSelector((state) => state.setting.country)
  const lng = useSelector((state) => state.common.lng)


  useEffect(() => {
    handleList()
  }, [])

  useEffect(() => {
    setData(defaultValue)
  }, [defaultValue])

  const handleList = (page, per_page, search = "") => {
    setLoading(true)
    Get(`basic-information/ship?page=${page || 1}&per_page=${per_page || 10}&q=${search}`).then((res) => {
      setData(res?.details?.data)
    }).finally(() => {
      setLoading(false)
    })
  }

  const handleEdit = (item) => {
    editItem(item)
  }

  const handleDelete = (item) => {
    setDeleteItem(item)
  }

  const handleCloseDeleteModal = () => {
    setDeleteItem(null)
  }

  const handleDeleteRequest = () => {
    setLoadingDelete(true)
    Delete(`basic-information/ship/destroy/${deleteItem.id}`).then((res) => {
      setData(res?.details?.data)
      toast.success(res.msg)
      setDeleteItem(null)
    }).finally(() => {
      setLoadingDelete(false)
    })
  }
  const handleSort = (e) => {
    setData([])
    setTimeout(() => {
      setData(e)
    }, 0)
  }
  const handleSearch = (e) => {

    clearTimeout(searchTime)


    let loop = setTimeout(() => {

      handleList(1, perPage, e);

    }, 1000)
    setSearchTime(loop)

  }
  const handleClose = () => {
    setFileModal("")
    onClose()
    onClear()
  }
  const handleDefault = (option) => {
    return defaultValueSelected?.find((item) => {
      return option.id === item
    })
  }

  const handleCountryTitle = (country_id) => {
    if (country_id && countryList)
      return countryList.find(i => i.id == country_id)[`${lng}_name`]
    return '-'
  }

  return (
    <div className={`${selectShip ? "w-full" : ""} my-container`}>
      {
        loading && <LoadingFix />
      }
      {
        deleteItem && <DeleteModal onClose={handleCloseDeleteModal} onDelete={handleDeleteRequest} loading={loadingDelete} />
      }
      {
        viewType === "WEB" ?
          <div className="relative overflow-x-auto w-full  bg-white rounded-lg  flex flex-col items-center w-full !mt-5 border border-1 border-gray-300  ">
            <table className="w-full text-sm text-gray-500">
              <thead className="text-xs text-gray-700 uppercase ">
                <tr className={"border-b border-gray-400"}>
                  <th scope="col" className="px-6 py-3 text-left w-4 font-normal text-gray-600 text-sm">
                    <div className={"mt-1"}>
                      {t("row")}
                    </div>
                  </th>
                  <th scope="col" className="px-6 py-3  text-right font-normal text-gray-600 text-sm">
                    <div className={"mt-1 flex"}>
                      <Sort data={data} sortKey={"name"} onSort={(e) => handleSort(e)} />
                      {t("shipName")}
                    </div>
                  </th>
                  <th scope="col" className="px-6 py-3  text-center font-normal text-gray-600 text-sm">
                    <div className={"mt-1 flex justify-center"}>
                      <Sort data={data} sortKey={"ship_type_id"} onSort={(e) => handleSort(e)} />
                      {t("shipType")}
                    </div>
                  </th>
                  <th scope="col" className={`px-6 py-3 text-center font-normal text-gray-600 text-sm `}>
                    <div className={"mt-1 flex justify-center"}>
                      <Sort data={data} sortKey={"owner"} onSort={(e) => handleSort(e)} />
                      {t("ownership")}
                    </div>
                  </th>
                  <th scope="col" className={`px-6 py-3 text-center font-normal text-gray-600 text-sm `}>
                    <div className={"mt-1 flex justify-center"}>
                      <Sort data={data} sortKey={"country_id"} onSort={(e) => handleSort(e)} />
                      {t("flag")}
                    </div>
                  </th>
                  <th scope="col" className="px-6 py-3 text-left font-normal text-gray-600 text-sm ">
                    <div className={"mt-1 flex justify-end"}>
                      <Sort data={data} sortKey={"imo"} onSort={(e) => handleSort(e)} />
                      IMO
                    </div>
                  </th>
                  <th scope="col" className="px-6 py-3 text-left font-normal text-gray-600 text-sm ">
                    <div className={"mt-1 flex justify-end"}>
                      {t("ShowDocuments")}
                    </div>
                  </th>
                  {
                    !selectShip &&
                    <th scope="col" className="px-6 py-3 text-left w-[200px] font-normal text-gray-600 text-sm">
                      <Search onChange={handleSearch} />
                    </th>
                  }

                </tr>
              </thead>
              <tbody>
                {data?.data?.map((item, index) => (
                  <tr key={index} className="bg-white border-b border-gray-400">
                    <td className="px-6 py-4 text-center">
                      <div className={"text-gray-500 text-sm mt-1"}>
                        {index + 1}
                      </div>
                    </td>
                    <td className="px-6 py-4 text-start text-primary-400 text-base font-semibold">
                      <div className={"mt-1"}>
                        {
                          selectShip ?
                            <div className={"mt-1"}>
                              <CustomCheckBox defaultValue={handleDefault(item) === item.id} label={item.name} id={item.id} onCheck={() => onChange(item.id)} />
                            </div>
                            :
                            item.name
                        }
                      </div>
                    </td>
                    <td className={`py-4 text-center`}>
                      <div className={"text-gray-900 text-sm mt-1"}>
                        {item?.ship_type?.fa_name}
                      </div>
                    </td>
                    <td className={`py-4 text-center`}>
                      <div className={"text-gray-900 text-sm mt-1"}>
                        {item.owner}
                      </div>
                    </td>
                    <td className={`py-4 text-center`}>
                      <div className={"text-gray-900 text-sm mt-1"}>
                        {handleCountryTitle(item.country_id)}
                      </div>
                    </td>
                    <td className={`pl-6 py-4 text-end ${directionClass ? "pl-6  " : "pr-4"}`}>
                      <div className={"text-gray-900 text-sm mt-1"}>
                        {item.imo}
                      </div>
                    </td>
                    <td className={`pl-12 py-4 text-end  ${directionClass ? "pl-12  " : "pr-12"}`}>
                      <a href={item.filepath?.includes("pdf") && "https://api.flysepehr.com/" + item.filepath} download={true} target={"_blank"} onClick={() => setFileModal("https://api.flysepehr.com/" + item.filepath)} className={"text-primary-300 text-sm mt-1 cursor-pointer"}>
                        {t("documentsTitle")}
                      </a>
                    </td>
                    <td className="px-6 py-4 text-right">
                      {
                        !selectShip &&
                        <div className={"flex justify-center cursor-pointer"}>
                          <button onClick={() => handleEdit(item)}>
                            <EditIcon />
                          </button>
                          <button onClick={() => handleDelete(item)}>
                            <DeleteIcon />
                          </button>
                        </div>
                      }

                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          :
          <div className={"grid gap-3 mt-3"}>
            <div className={"bg-white p-3 rounded-lg flex gap-5"}>
              <Filter />
              <div className={"w-full"}>
                <Search onChange={handleSearch} />
              </div>
            </div>
            {
              data?.data?.map((item, index) => {
                return (
                  <div className={"flex p-4 rounded-lg bg-white"}>
                    <div className={"flex w-full"}>
                      <div className={"ml-5 min-w-7"}>{index + 1}</div>
                      <div className={"flex w-full flex-wrap gap-y-8 justify-between"}>
                        <div className={"flex w-1/3"}> {
                          selectShip ?
                            <div className={"mt-1"}>
                              <CustomCheckBox label={item.name} id={item.id} onCheck={() => onChange(item.id)} />
                            </div>
                            :
                            item.name
                        }</div>
                        <div className={"flex w-1/3 text-sm text-gray-900 justify-center"}>{item.owner}</div>
                        <div className={"flex w-1/3 text-sm text-gray-900 text-center justify-center"}>{item.imo}</div>
                        <div className='w-1/3 flex flex-row justify-start gap-2 items-center'>
                          <a href={item.filepath?.includes("pdf") && "https://api.flysepehr.com/" + item.filepath} download={true} target={"_blank"} onClick={() => setFileModal("https://api.flysepehr.com/" + item.filepath)} className={"flex  text-sm text-primary-300 "}> {t("documentsTitle")}</a>
                          <span className='text-gray-400'>|</span>
                          <div className={"flex w-1/3 text-sm text-gray-900 text-center justify-center"}>{item.ship_type?.fa_name}</div>
                        </div>
                        <div className='flex w-1/3 text-sm text-gray-900 text-center justify-center'>{handleCountryTitle(item.country_id)}</div>
                        <div className={"flex w-1/3 justify-center"}>
                          {
                            !selectShip &&
                            <div className={"flex justify-center cursor-pointer"}>
                              <button onClick={() => handleEdit(item)}>
                                <EditIcon />
                              </button>
                              <button onClick={() => handleDelete(item)}>
                                <DeleteIcon />
                              </button>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </div>
      }
      <div onClick={(e) => e.target === e.currentTarget && handleClose()} className={`${fileModal && !fileModal?.includes("pdf") ? "flex" : "hidden"} bg-modal h-full w-full fixed top-0 right-0 z-30  items-center justify-center z-40`}>
        <div className={"bg-white rounded-2xl p-5 h-[80%] w-[80%] flex justify-center items-center relative"}>
          <div className={"absolute left-5 top-5 flex items-center mb-8 justify-between"}>
            <span onClick={() => handleClose()} className={"cursor-pointer"}>
              <Close color={"#8A9098"} />
            </span>
          </div>
          <img className={"max-h-[90%] max-w-[90%]"} src={fileModal} />
        </div>
      </div>
      <div className={'flex flex-col  md:flex-row md:items-center md:justify-between mt-4'}>
        <DropDown onChange={(per_page) => {
          handleList(1, per_page)
          setPerPage(per_page)
        }} />
        <Pagination itemsPerPage={data?.per_page} total={data?.total} last_page={data?.last_page} changePage={(page) => handleList(page, perPage)} />
      </div>
    </div>
  );
};


export default ShipTable;

